import { render, staticRenderFns } from "./WorkflowOverview.vue?vue&type=template&id=bedfe2c0&"
import script from "./WorkflowOverview.vue?vue&type=script&lang=ts&"
export * from "./WorkflowOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports